import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default function Person(props) {
  return (
    <SvgIcon {...props}>
      <path d="M21.122 17.775c-.506-.36-1.088-.564-1.7-.723-1.581-.414-3.37-.522-4.617-2.174 0 0-.645-.725.804-2.496 1.449-1.77 1.57-4.587 1.207-6.76C16.454 3.448 14.4 2 12.268 2c-2.132 0-4.184 1.449-4.546 3.621-.362 2.174-.242 4.99 1.207 6.761 1.449 1.77.805 2.496.805 2.496-1.24 1.64-3.012 1.759-4.585 2.164-.624.162-1.218.366-1.733.733C1.606 19.062 2.048 22 2.048 22H22.49s.443-2.938-1.368-4.225"/>
    </SvgIcon>
  );
}